import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import AppointmentModalStore from './store';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const AppointmentModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.appointmentModalRoot)}>
        <div className="appointment-modal-root">
          <div className="appointment-modal-group-1" data-name="小程序预约">
            <div className="appointment-modal-layer-1" />
            <div className="appointment-modal-group-2" data-name="内容">
              <div className="appointment-modal-layer-2" />
              <div className="appointment-modal-layer-3" />
              <div className="appointment-modal-layer-4" onClick={() => store.appointmentByMiniprogram()} />
              <div className="appointment-modal-layer-5" onClick={() => store.appointmentByPhone()} />
            </div>

            <Link
              className="appointment-modal-layer-6"
              onClick={() => {
                store.onClickClose();
                onClose();
              }}
            />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentModal, AppointmentModalStore);
